// extracted by mini-css-extract-plugin
module.exports = {"macroVarselboks":"MacroVarselBoks_macroVarselboks__x9iqK"};